import React from "react";

/**
 * SafetyChecklistSectionHeader
 *
 * Shared visual section header band for Safety Checklists.
 * Rendered across Maker Create, Maker Fix, Checker Review, Readonly modal, History modal, and Setup preview.
 *
 * Background: #E2EFDB (Soft pastel green)
 * Text: #0070C0 (Deep crisp blue)
 */
function SafetyChecklistSectionHeader({ label, className = "", style = {} }) {
  if (!label) return null;

  return (
    <div
      role="heading"
      aria-level="3"
      className={`w-full rounded-xl border border-[#c6dfbe] bg-[#e2efdb] px-4 py-2.5 text-center shadow-xs my-4 transition-all ${className}`}
      style={{
        backgroundColor: "#e2efdb",
        borderColor: "#c6dfbe",
        ...style,
      }}
    >
      <span className="text-xs sm:text-sm font-bold tracking-wider text-[#0070c0] uppercase select-none">
        {label}
      </span>
    </div>
  );
}

export default SafetyChecklistSectionHeader;
